import React from 'react';
import Section from '../components/Section';
import CheckItem from '../components/CheckItem';
import { useAbout } from '../data';

/*
 * §7.1.2 — "living blueprint" About: faint blueprint grid, technical-drawing
 * corner brackets on the image, a slowly-rotating credential seal, an offset
 * accent frame, and a spec-sheet checklist. All text/image stay data-driven.
 */
export default function AboutSection() {
  const about = useAbout();
  return (
    <Section id="about" className="about">
      <div className="about__bg" aria-hidden="true" />
      <div className="about__grid">
        <div className="about__text">
          <p className="about__eyebrow">
            {about.eyebrow}
            <span className="about__eyebrow-rule" aria-hidden="true" />
          </p>
          <h2 className="about__title">{about.title}</h2>
          <p className="about__para">{about.paragraph}</p>
          <ul className="about__checklist">
            {about.checklist.map((item) => (
              <CheckItem key={item}>{item}</CheckItem>
            ))}
          </ul>
        </div>

        <div className="about__media">
          <div className="about__frame" aria-hidden="true" />
          <div className="about__imgwrap">
            <img className="about__img" src={about.image} alt="" loading="lazy" />
            <span className="about__corner about__corner--tl" aria-hidden="true" />
            <span className="about__corner about__corner--tr" aria-hidden="true" />
            <span className="about__corner about__corner--bl" aria-hidden="true" />
            <span className="about__corner about__corner--br" aria-hidden="true" />
          </div>

          <div className="about__seal" aria-hidden="true">
            <svg viewBox="0 0 120 120" className="about__seal-svg">
              <defs>
                <path id="aboutSeal" d="M60 16 a44 44 0 1 1 0 88 a44 44 0 1 1 0 -88" />
              </defs>
              <text className="about__seal-text">
                <textPath href="#aboutSeal" startOffset="0">
                  • LICENSED ENGINEERS • TRUSTED EXPERTISE • PRECISION BUILT&nbsp;
                </textPath>
              </text>
            </svg>
            <span className="about__seal-core">
              <span className="about__seal-num">10+</span>
              <span className="about__seal-label">years</span>
            </span>
          </div>
        </div>
      </div>
    </Section>
  );
}
